var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0653 9.31443L14.3307 6.0491L3.98933 0.341099C3.58475 0.116271 3.12932 -0.00115844 2.66646 8.6146e-06C2.20361 0.00117567 1.74878 0.120901 1.34533 0.347766L11.0653 9.31443ZM0.373333 1.2651C0.136 1.6531 0 2.0971 0 2.56777V18.7624C0 19.2184 0.124 19.6531 0.348 20.0331L10.1227 10.2584L0.373333 1.2651ZM18.66 8.43843L15.5453 6.71977L12.0453 10.2184L16.3347 14.1744L18.6613 12.8904C19.4987 12.4264 20 11.5944 20 10.6638C19.9992 10.2062 19.8741 9.75755 19.6381 9.3656C19.4021 8.97365 19.064 8.65318 18.66 8.43843ZM11.1027 11.1624L1.30133 20.9638C1.7151 21.2038 2.18435 21.3315 2.66267 21.3344C3.116 21.3344 3.572 21.2198 3.98933 20.9891L15.1053 14.8544L11.1027 11.1624Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/google-play.f10577efafd68ddc3fc4fe9166724abe.svg";
export { ForwardRef as ReactComponent };